import { useGlobalContext } from "contexts";
import { useEffect } from "react";

export const useQuizFocus = () => {
    const globalContext = useGlobalContext();
    useEffect(() => {
        //@ts-ignore
        document.getElementsByTagName("body")[0].style = 'overflow: hidden';
        globalContext.toggleQuizFocusVisiblity!(true);
      
        return () => {
            //@ts-ignore
            document.getElementsByTagName("body")[0].style = '';
            globalContext.toggleQuizFocusVisiblity!(false);
        };
      }, [globalContext.toggleQuizFocusVisiblity]);
};